import { makeAutoObservable } from "mobx";
import { ASAPFulfillmentTime } from "../FulfillmentTime";
import { Availability } from "../Availability";
/**
 * How and where should the order be fulfilled for QrWaiter order.
 */
export class QrWaiterFulfillmentInstructions {
    constructor(params) {
        this.type = "QrWaiter";
        this.isDelivery = false;
        this.streetAddress = null;
        this.apartmentInfo = null;
        /**
         * A way in which the order will be physically fulfilled - DineIn
         */
        this.fulfillmentMethodType = "DineIn";
        this.fulfillmentTime = new ASAPFulfillmentTime();
        this.userNote = params.userNote;
        this.paymentMedium = params.paymentMedium;
        this.paymentMediumRestored = params.paymentMediumRestored;
        this.dineInLocationNumber = params.dineInLocationNumber;
        makeAutoObservable(this);
    }
    get paymentAvailability() {
        return Availability.boolean({
            PaymentMediumMissing: this.paymentMedium === null,
        });
    }
    get availability() {
        return Availability.composite([
            this.paymentAvailability,
            this.userNote.availability,
        ]);
    }
    get fulfillmentMethodCheckoutData() {
        return {
            tag: this.fulfillmentMethodType,
            // TODO: Remove `as DineInLocation` when the DSL generated Typescript type will be correct (with `tag` prop)
            location: {
                tag: "Table",
                number: this.dineInLocationNumber,
            },
        };
    }
    get paymentMethod() {
        // TODO: default payment medium / method?
        if (!this.paymentMedium) {
            return "Cash";
        }
        switch (this.paymentMedium.type) {
            case "method":
                return this.paymentMedium.method;
            case "channel":
                return "Online";
        }
    }
    /**
     * @returns data to be sent to the backend
     */
    get checkoutData() {
        return {
            fulfillmentMethod: this.fulfillmentMethodCheckoutData,
            paymentMethod: this.paymentMethod,
            requestedFulfillmentTime: this.fulfillmentTime.checkoutData,
            userNote: this.userNote.checkoutData,
        };
    }
    get fulfillmentMethod() {
        return this.fulfillmentMethodType;
    }
    get paymentData() {
        if (this.paymentMedium === null) {
            return null;
        }
        if (this.paymentMedium.type === "channel") {
            return {
                applePayToken: null,
                channel: this.paymentMedium.channelId,
                blikCode: null,
                cardToken: null,
                isIosApp: false,
            };
        }
        return null;
    }
}
